import { getSubdomain } from './getSubdomain';

const defaultNonProdSubdomains = ['localhost', 'dev', 'qa', 'demo'];

export function isNonProdEnv(extraNonProdEnvs?: string[]): boolean {
  const currentSubdomain = getSubdomain().toLowerCase();
  return defaultNonProdSubdomains
    .concat(extraNonProdEnvs || [])
    .includes(currentSubdomain);
}
